import { fetchAppDetailsActions,fetchAppTopSecActions } from "./actions";

const initialState = {
  appDataStatus: null,
  appTopSecData: [],
  appTopSecStatus: null,
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchAppTopSecActions.FETCH_APPLICATION_TOP_SEC_SUCCESS:
      return {
        ...state,
        appTopSecData: action.payload.data,
        appTopSecStatus: action.payload.status
      };
    case fetchAppTopSecActions.FETCH_APPLICATION_TOP_SEC_ERROR:
      return {
        ...state,
        appTopSecData: [],
        appTopSecStatus: action.payload.status
      };

    default:
      return state;
  }
};

export default appReducer;
